import styled from 'styled-components';
import { sizes, SCREEN_SIZES } from 'style';
import NotFound from 'components/NotFound';

const StyledNotFound = styled(NotFound)`
  img {
    @media (max-width: ${SCREEN_SIZES.tabletPortrait}px) {
      margin-top: -120px;
    }
  }
  > section > div:last-child {
    @media ${sizes.desktop} {
      max-width: 600px;
    }
  }
`;

export default StyledNotFound;
